/* =====================================================================
   RYNOR – shipping price in the cart drawer
   Theme editor › Footer › "Cart: shipping cost line" › Where to show it:
     off     nothing, the cart looks like it always did
     top     "US shipping $5.95 — free on orders $75+" under the free-shipping bar,
             until the cart reaches free shipping
     bottom  replaces "Taxes & Shipping calculated at checkout" above the Checkout button with
             "US shipping $5.95 — free on orders $75+" + "Taxes calculated at checkout",
             or "Free US shipping" + "Taxes calculated at checkout" once the cart qualifies
   (sections/rynor-cart-shipping-line.liquid puts the settings in <script data-rynor-ship-cost-config>).

   The cart total and free-shipping amount are read from the bar's own numbers
   (snippets/cart-shipping-countdown.liquid), so the text always agrees with the bar.
   Shoppers paying in another currency get the price converted with Shopify's live rate, the
   same way the bar converts (assets/rynor-i18n.js).
   ===================================================================== */
(function () {
  'use strict';

  if (window.RynorShipCost) return;

  var queued = false;

  function config() {
    var el = document.querySelector('script[data-rynor-ship-cost-config]');
    if (!el) return null;
    try { return JSON.parse(el.textContent || '{}'); } catch (e) { return null; }
  }

  function placement(cfg) {
    if (!cfg) return 'off';
    if (cfg.placement) return String(cfg.placement);
    return cfg.enabled ? 'top' : 'off'; /* older saved setting */
  }

  function scope() {
    return document.getElementById('slideout-ajax-cart') || document;
  }

  /* the cart's latest render (cart-form re-draws this <template> after every change);
     before the drawer has loaded, the bar's own server-rendered numbers */
  function freshNumbers(bar) {
    return scope().querySelector('template[data-rynor-free-ship]') || bar;
  }

  /* assets/cart.js empties the cart by hiding the form, without re-drawing it */
  function cartEmptied() {
    var form = scope().querySelector('.js-cart-form');
    return !!(form && form.classList.contains('hide'));
  }

  function formatRate(shopCents, sameCurrency) {
    var I = window.RynorI18n;
    if (!I) return '$' + (shopCents / 100).toFixed(2);
    return I.formatLocalCents(sameCurrency ? shopCents : I.toLocalCents(shopCents));
  }

  function formatThreshold(shopCents) {
    var I = window.RynorI18n;
    if (!I) return '$' + Math.round(shopCents / 100);
    return I.formatThreshold(shopCents);
  }

  /* ---------- top: the small line under the free-shipping bar ---------- */
  function renderTop(bar, show, text) {
    var line = bar && bar.querySelector('[data-rynor-ship-cost]');
    if (!show) {
      if (line) line.hidden = true;
      return;
    }
    if (!line) {
      line = document.createElement('p');
      line.className = 'rynor-ship-cost';
      line.setAttribute('data-rynor-ship-cost', '');
      bar.appendChild(line);
    }
    if (line.textContent !== text) line.textContent = text;
    line.hidden = false;
  }

  /* ---------- bottom: the note above the Checkout button ---------- */
  function restoreNote(note) {
    if (note.__rynorOriginal == null) return;
    note.innerHTML = note.__rynorOriginal;
    note.__rynorOriginal = null;
    note.__rynorKey = '';
    note.classList.remove('rynor-ship-note');
  }

  function renderBottom(show, shipText, taxText) {
    var notes = scope().querySelectorAll('.ajax-cart__taxes-duties-note');
    Array.prototype.forEach.call(notes, function (note) {
      if (!show) { restoreNote(note); return; }
      var key = shipText + '|' + taxText;
      if (note.__rynorKey === key) return;
      if (note.__rynorOriginal == null) note.__rynorOriginal = note.innerHTML;
      var a = document.createElement('span');
      a.className = 'rynor-ship-note__ship';
      a.textContent = shipText;
      var b = document.createElement('span');
      b.className = 'rynor-ship-note__tax';
      b.textContent = taxText;
      note.innerHTML = '';
      note.appendChild(a);
      note.appendChild(b);
      note.classList.add('rynor-ship-note');
      note.__rynorKey = key;
    });
  }

  function render() {
    queued = false;

    var cfg = config();
    var where = placement(cfg);
    var usable = !!(cfg && cfg.rate_cents > 0 && cfg.text);

    var bar = scope().querySelector('.cart-shipping-countdown');
    var from = bar ? freshNumbers(bar) : null;
    var thresholdShop = from ? (parseInt(from.getAttribute('data-threshold-shop-cents'), 10) || 0) : 0;
    var total = (!from || cartEmptied()) ? 0 : (parseInt(from.getAttribute('data-total-cents'), 10) || 0);
    var same = !from || from.getAttribute('data-same-currency') !== 'false';

    /* free-shipping amount in the cart's currency, worked out like the bar does */
    var threshold = thresholdShop;
    if (!same) {
      var I = window.RynorI18n;
      threshold = I ? Math.ceil(I.toLocalCents(thresholdShop) / 100) * 100 : 0;
    }
    var known = usable && thresholdShop > 1 && threshold > 0;
    var under = known && total > 0 && total < threshold;
    var text = known ? String(cfg.text)
      .replace('[rate]', formatRate(cfg.rate_cents, same))
      .replace('[threshold]', formatThreshold(thresholdShop)) : '';

    /* top: only while the cart is under free shipping */
    if (bar) renderTop(bar, where === 'top' && under, text);

    /* bottom: shipping price (or "Free US shipping") + taxes line */
    var bottom = where === 'bottom' && known && total > 0;
    renderBottom(bottom, bottom ? (under ? text : String(cfg.free_text || '')) : '', String((cfg && cfg.tax_text) || ''));
  }

  function queue() {
    if (queued) return;
    queued = true;
    if (window.requestAnimationFrame) window.requestAnimationFrame(render);
    else window.setTimeout(render, 16);
  }

  var observer = new MutationObserver(queue);

  function watch() {
    Array.prototype.forEach.call(document.querySelectorAll('.js-ajax-cart-content'), function (el) {
      if (el.__rynorShipCostWatched) return;
      el.__rynorShipCostWatched = true;
      observer.observe(el, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    });
  }

  function init() {
    watch();
    render();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.addEventListener('load', queue);

  /* theme editor: the setting was changed or a price typed in */
  document.addEventListener('shopify:section:load', function () {
    watch();
    queue();
  });

  window.RynorShipCost = { refresh: render };
})();
